<template>
  <v-app-bar elevation="0" :color="mainColour">
    <v-app-bar-nav-icon @click="$emit('toggleSidebar')"></v-app-bar-nav-icon>

    <v-img
      class="mx-2"
      src="@/v3/assets/2025/readychek_logo.png"
      max-width="170"
      max-height="90"
      contain
    ></v-img>

    <v-spacer></v-spacer>

    <div class="text-h5">
      <v-btn
        v-if="hasMultipleCompanies"
        variant="text"
        class="text-h5 text-capitalize"
        @click="$emit('navigate', 'selectCompany')"
      >
        {{ companyName }}
      </v-btn>
      <span v-else>{{ companyName }}</span>
    </div>

    <v-spacer></v-spacer>

    <div class="d-flex align-center mr-2">
      <span class="text-body-2 mr-2 d-none d-sm-flex">Hi, {{ userInfo.firstName }}!</span>
      
      <v-menu location="bottom">
        <template v-slot:activator="{ props }">
          <v-btn icon v-bind="props">
            <v-icon size="x-large">mdi-account-outline</v-icon>
          </v-btn>
        </template>
        
        <v-list>
          <v-list-item
            v-for="item in profileMenuItems"
            :key="item.value"
            @click="handleMenuClick(item.value)"
            :prepend-icon="item.icon"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </v-app-bar>

  <SignOutDialog v-show="showSignOut" @close="closeSignOutDialog" />
</template>

<script setup>
import { ref, computed } from 'vue';
import { useTheme } from 'vuetify';
import { useRouter } from 'vue-router';
import ConstUtils from '@/utils/ConstUtils.js';
import SignOutDialog from "@/portals/customer/operator/views/sign/out/SignOutDialog.vue";

const props = defineProps({
    companyName: { type: String, default: 'ReadyChek' },
    hasMultipleCompanies: { type: Boolean, default: false },
    userInfo: { type: Object, default: () => ({ firstName: 'Guest', idEncoded: null }) },
});

const emit = defineEmits(['toggleSidebar', 'navigate']);

const theme = useTheme();
const router = useRouter();
const showSignOut = ref(false);

const profileMenuItems = ref([
    { title: 'Profile', value: 'profile', icon: 'mdi-account-circle-outline' },
    { title: 'Sign Out', value: 'signOut', icon: 'mdi-logout' },
]);

const mainColour = computed(() => {
    return theme.global.name.value === 'dark' ? 'grey-darken-4' : 'grey-lighten-4';
});

const handleMenuClick = (action) => {
    if (action === 'profile') {
        const path = `users/${props.userInfo.idEncoded}/profile`;
        emit('navigate', path);
    } else if (action === 'signOut') {
        showSignOut.value = true;
    }
    };

const closeSignOutDialog = (buttonData) => {
    showSignOut.value = false;
    if (buttonData) {
        router.replace({ name: ConstUtils.ROUTES.SIGNIN });
    }
};
</script>